import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import PracticePeopleSolicitors from '../practice-people-solicitors/index.vue';
import PracticePeopleSignatories from '../practice-people-signatories/index.vue';
import PracticePeopleDirectors from '../practice-people-directors/index.vue';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { TrustAPI } from '@/shared/modules/trust-api';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import { PracticeView } from '@/shared/modules/typescript-trustapi-client/models';
import PracticePeopleTrustCoordinator from '../practice-people-trust-coordinator/index.vue';
import PracticePeopleAuthorisedTrustContact from '../practice-people-authorised-trust-contact/index.vue';
@Options({
  components: {
    LoadingIndicator,
    PracticePeopleSolicitors,
    PracticePeopleSignatories,
    PracticePeopleDirectors,
    PracticePeopleTrustCoordinator,
    PracticePeopleAuthorisedTrustContact,
  }
})
export default class PracticePeople extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private showMode = '1';

  private stat = [];
  private loadingStat = false;

  mounted() {
    window.scrollTo(0, 0);
    this.loadStatData();
  }

  private loadStatData() {
    this.loadingStat = true;
    this.apiService.PeopleApi?.apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(
        this.selectedPractice.id
      ).then((res: any) => {
        this.stat = res.data.data;
        this.loadingStat = false;
      })
      .catch((err: any) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get solicitor stat');
        this.ai.trackException('Error getting investigations: ' + err);
        this.loadingStat = false;
      })

  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

}


